module.exports = __webpack_public_path__ + "img/violations.6d920f0c.svg";